let step = 1;
const MAX_STEPS = 3;
const designBtns = document.querySelectorAll('[data-action]');
const flowSteps = document.querySelectorAll('.step-content');
const addToCartButton = document.querySelector('#AddToCart');
const indicationContainers = document.querySelectorAll('.img-container');
let action = null;
let isProductAdded = false;


const showActiveStep = ()=>{
    indicationContainers[step-1].classList.add('current');
}


const addDesignEventListeners = ()=>{
    designBtns.forEach((btn, index) => {
        btn.addEventListener('click', (ev) => {
            if (!ev.target.classList.contains('selected')) {
                ev.target.classList.add('selected')
                action = ev.target.getAttribute('data-action')
                selectedIndex = index
                localStorage.setItem('action', action)
                if(action == 'existing'){
                    markStepAsCompleted(0)
                    markStepAsCompleted(1)
                    step += 2;
                }else{
                    markStepAsCompleted(0)
                    step++;
                }
              
                deselectOthers();
                showActiveStep();
               
            displayStepContent(step-1);
            } else {
                ev.target.classList.remove('selected')
                selectedIndex = null
                action = null;
            }
        })
    })
}

const addAdtoCartButtonListener = ()=>{
    addToCartButton.addEventListener('click', ev => {
    
            if (isProductAdded) {
                ev.preventDefault();
                return displayError(true);
            }
            isProductAdded = true;
            markStepAsCompleted(1)
            step++;
            displayStepContent(step-1);
            showActiveStep();
        })
}

let selectedIndex = null
const initFLow = () => {
    localStorage.setItem('action', action);

    if(step)
    addDesignEventListeners();
    addAdtoCartButtonListener();

    displayStepContent(step - 1)
    showActiveStep();
    switch (step){
        case 2:{
            markStepAsCompleted(0);
            break;
        }
        case 3:{
            markStepAsCompleted(0);
            markStepAsCompleted(1);
            break;
        }
    }

    const customTextInput = document.querySelector('.line-item-property__field');
    customTextInput.style.display = "block";
}
const setStepParam = (step)=>{
    const url = new URL (window.location.href);
    const params = new URLSearchParams(url);   
    params.set('step',step+1)
    history.pushState(null, null, "?"+params.toString());
}


const displayStepContent = (step) => {
    setStepParam(step);
    flowSteps.forEach((stepContent, i) => {
        if (i === step) {
            stepContent.style.display = 'block';
          
        } else {
            stepContent.style.display = 'none';
        }
    })
}

const markStepAsCompleted = (step) => {

    const number =  indicationContainers[step].querySelector('.number');

    console.log({number});

    const checkmark =  indicationContainers[step].querySelector('.checked-text');

    indicationContainers[step].style.background = '#ecd4cf';

    number.style.display = 'none';
    checkmark.style.display = 'block';
  
}

const markStepAsInCompleted = (step) => {

    const number =  indicationContainers[step].querySelector('.number');

    const checkmark =  indicationContainers[step].querySelector('.checked-text');

    indicationContainers[step].style.background = 'white';
    console.log(number);

    number.style.display = 'block';
    checkmark.style.display = 'none';
  
}

const isStepValid = () => {
    let isValid = false;
    switch (step) {
        case 1: {
            designBtns.forEach(btn => {
                if (btn.classList.contains('selected')) {
                    isValid = true;
                }
            });
            if (!isValid) {
                localStorage.setItem('action', action)
            }

            break
        }
        case 2: {
            isValid = isProductAdded;
            break;
        }
        default: {
            isValid = true;
        }
    }
    console.log(isValid)
    return isValid;
}

const displayError = (customError = false) => {
    const stepErrors = {
        "1": "Please choose a design Option",
        "2": "Please Add Product"
    }
    const customErrors = {
        "2": "Product Already Added"
    }
    return alert(customError ? customErrors[step] : stepErrors[step]);
}

const changeStep = () => {

    // prevBtn.addEventListener('click', () => {
    //     if (step === 3 && action === 'existing') {
    //         step -= 2;
    //         markStepAsInCompleted(0);
    //         markStepAsInCompleted(1);
    //         displayStepContent(0);
    //         return
    //     }
    //     if (step > 1) {
    //         markStepAsInCompleted(step-2);
    //         step--;
    //     }
    //     displayStepContent(step - 1)
       
    // })
    // nextBtn.addEventListener('click', () => {
    //     if (!isStepValid()) {
    //         return displayError()
    //     }
    //     if (step === 1 && action === 'existing') {
    //         step += 2;
    //         markStepAsCompleted(step-2);
    //         markStepAsCompleted(step-3);
    //         displayStepContent(2);
    //         return;
    //     }
    //     if (step < MAX_STEPS) {
    //         step++;
    //         markStepAsCompleted(step-2);
    //     }

    //     displayStepContent(step - 1)
    // })
}
const deselectOthers = () => {
    designBtns.forEach((btn, index) => {
        if (index !== selectedIndex) {
            btn.classList.remove('selected')
        }
    })
}

const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    step = +urlParams.get('step')
    if(!step){
        step = 1;  
    }else{
        action = localStorage.getItem('action');
    }
    if(step >MAX_STEPS){
        step = 1;
    }

initFLow();
changeStep();